<template>

  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          " toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Other Common Overseas</b-navbar-brand>
          <b-navbar-nav class="ml-auto" center>
            <b-nav-form>
              <b-button @click="filterClear">Clear</b-button>
              <!-- <b-button
                size="sm"
                class="ml-1 mr-1"
                @click="getReportsReverse('Others_Common_Overses_EXCEL')"
                variant="outline-info"
              >Export</b-button> -->
              <b-button :disabled="ExcelBtnName != 'Export' ? true : false" class="ml-1 mr-1"
                @click="getReportsReverse('Others_Common_Overses_EXCEL', 'Export')" size="sm" variant="outline-info">{{
                ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export'" small label="Small Spinner"></b-spinner></b-button>
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card>
          <b-row class="mt-2">
            <b-col md="3">
              <label for="blType">To</label>
              <model-list-select :list="$store.getters['common/getAllAgentColoaderList']" option-value="agentName"
                option-text="agentName" v-model="Filter.ToFilter" placeholder="Select To"
                @input="SearchFilter"></model-list-select>
            </b-col>

            <b-col md="3">
              <label>Date :</label>
              <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                :startDate="startDate" :endDate="endDate" :locale-data="locale"
                @update="SearchFilter"></date-range-picker>
            </b-col>
            <b-col md="3">
              <label for="blType">Client</label>
              <model-list-select :list="$store.getters['common/getAllClientList']" id="clientNamenew"
                v-model="Filter.clientIdFilter" option-value="clientId" option-text="clientName"
                placeholder="Select Client Name" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>POR</label>
              <model-list-select @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                :list="$store.getters['common/getAllPORList']" v-model="Filter.PORfilter" option-value="pickupId"
                option-text="pickupLocation" placeholder="Select Place of Receipt"
                @update="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>POD</label>
              <model-list-select @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                :list="$store.getters['common/getAllPODList']" v-model="Filter.PODfilter" option-value="pickupId"
                option-text="pickupLocation" placeholder="Select Port of Discharge"
                @update="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>Container Type</label>
              <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
                v-model="Filter.containerTypeFilter" option-value="containerTypeId" option-text="containerType"
                placeholder="Select Container Type" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>Shipping Line</label>
              <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                v-model="Filter.shippingLineFilter" option-value="shippingId" option-text="shippingLine"
                placeholder="Select Shipping Line" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>Air Line</label>
              <model-list-select :list="$store.getters['common/getAllAirLineList']" v-model="Filter.airLineFilter"
                option-value="airlineId" option-text="airlineName" placeholder="Select Air Line"
                @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>Type</label>
              <model-list-select :list="shipmentTypeList" v-model="Filter.shipmentTypeFilter" option-value="payVal"
                option-text="payText" placeholder="Select Status" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col md="3">
              <label>MANIFESTATION STATUS</label>
              <model-list-select @input="SearchFilter" :list="ManifestationStatusList" v-model="Filter.statusFilter"
                option-value="inv" option-text="int" placeholder="Select Manifestation"></model-list-select>
            </b-col>

            <b-col md="2">
              <label>CLOSE STATUS</label>
              <model-list-select @input="SearchFilter" :list="CLosedStatusList" v-model="Filter.closedFilter"
                option-value="inv" option-text="int" placeholder="Select Close Status"></model-list-select>
            </b-col>

            <b-col md="3">
              <label for="blType">Common Filter</label>
              <b-form-input :formatter="capitalizeAll" v-model="Filter.CommonFilter" @input="SearchFilter"
                placeholder="Type To Search (Assignment No. / Client / Container No. / Shipping Line / BL NO / CR/DR NO / HBL )" />
            </b-col>
            <b-col md="3">
              <label>Branch</label>
              <model-list-select class="ml-1" :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                v-model="Filter.branchfilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                @input="SearchFilter" :isDisabled="
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? true
                    : false
                "></model-list-select>
            </b-col>
            <b-col class="mt-4"></b-col>
          </b-row>
          <b-row class="align-content-end mt-3">
            <b-col cols="2">
              <h5 class="text-muted pull-right">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
            </b-col>
          </b-row>
        </b-card>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table show-empty stacked="md" :items="Others_Common_Overses_data" responsive :fields="Columns"
            primary-key="common_over_id" :per-page="pagination.perPage" :current-page="pagination.currentPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" class="position-relative">
            <template slot="common_over_id" slot-scope="row0">
              <span>
                {{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}
              </span>
            </template>
            <template slot="mainSalesSeries" slot-scope="row4">
              <span>
                Ass No:
                <b>{{ row4.item.mainSalesSeries }}</b>
              </span>
              <br />
              <span>
                Ass Date:
                <b>{{ row4.item.assDate }}</b>
              </span>
              <br />
              <span>
                Raised From:
                <b>{{ row4.item.raisedFrom }}</b>
              </span>
              <br />
              <span>
                Raised By:
                <b>{{ row4.item.raiesdBy }}</b>
              </span>
              <br />

              <span>
                Ass Type:
                <b>{{
                  row4.item.over_Transport_Type +
                  " ( " +
                  row4.item.over_shipmentType +
                  " )"
                  }}</b>
              </span>
              <br />
            </template>
            <template slot="over_type" slot-scope="row2">
              <span variant="info">
                <b>
                  {{ row2.item.over_type }}
                </b>
              </span>
              <br />
            </template>
            <template slot="agent_coloder_txt" slot-scope="row3">
              <span variant="info">
                <b>{{ row3.item.agent_coloder_txt }}</b>
              </span>
              <br />
            </template>
            <template slot="POR" slot-scope="row3">
              <span variant="info" v-if="row3.item.over_shipmentType == 'Sea'">
                <b>{{ "Stuffing : " + row3.item.STUFF }}</b>
                <br />
                <b>{{ "Handover : " + row3.item.HAND }}</b>
                <br />
                <b>{{ "Pickup : " + row3.item.PICK }}</b>
                <br />
                <b>{{ "LP : " + row3.item.POL }}</b>
                <br />
                <b>{{ "POR : " + row3.item.POR }}</b>
                <br />
                <b>{{ "POD : " + row3.item.POD }}</b>
                <br />
                <b>{{ "FPOD : " + row3.item.FPOD }}</b>
                <br />
              </span>
              <span variant="info" v-else-if="row3.item.over_shipmentType == 'Sea'">
                <b>{{ "Departure Airport : " + row3.item.AirDept }}</b>
                <br />
                <b>{{ "Destination Airport : " + row3.item.airDesti }}</b>
              </span>
              <br />
            </template>
            <template slot="MBLNO" slot-scope="row4">
              <b>{{ "MBL NO.:-" + row4.item.MBLNO }}</b>
              <br />
              <b>{{ "HBL NO.:-" + row4.item.HBLNO }}</b>
              <br />
              <div v-if="row4.item.containerNo != null">
                <b>{{ "CONT NO.:-" }}</b>
                <span v-for="(item, index) in row4.item.containerNo.split(',')" :key="index">
                  <h6>
                    <b-badge variant="light">{{ item + " " }}</b-badge>
                  </h6>
                </span>
              </div>

              <br />
              <b>{{ "CONT TYPE.:-" + row4.item.containerType }}</b>
              <br />
            </template>
            <template slot="CountmainManifestationData" slot-scope="row6">

              <b-button @click="
                  row6.item.CountmainManifestationData != 0
                    ? sendCommonManifestation(row6.item)
                    : ''
                " size="sm" :variant="
                  row6.item.CountmainManifestationData == 0
                    ? 'outline-danger'
                    : 'outline-success'
                ">{{
                row6.item.CountmainManifestationData == 0 ? "Pending" : "Received"
                }}</b-button>
              <b-badge variant="danger" v-if="row6.item.newManiFestCount>0"><b>New Manifestation
                  {{row6.item.newManiFestCount}}</b><br /></b-badge>

              <span v-for="(CDitem, CD_index) in row6.item.NoteDetails" :key="CD_index">
                <b-badge class="p-2 ml-2 mt-2" variant="warning"
                  v-if="CDitem.uploadCreditDebit != '' && CDitem.approvalStatus == '1'"
                  @click="PrintNote(row6.item.mainSalesSeries, CDitem.uploadCreditDebit)" size="sm">
                  <span>{{ CDitem.creditDebitNoteType == 2 ? "Debit" : "Credit" }} PDF</span>
                </b-badge>
              </span>
            </template>

            <template slot="action" slot-scope="row5">
              <!-- {{row5.item}} -->
              <span>
                <b-button @click="
                    row5.item.over_closedOverseas_status == 1
                      ? openCloseOverseasModal(row5.item)
                      : ''
                  " size="sm" :variant="
                    row5.item.over_closedOverseas_status == 1
                      ? 'outline-danger'
                      : 'success'
                  ">{{
                  row5.item.over_closedOverseas_status == 1 ? "Close" : "Closed"
                  }}</b-button>
                <br />
                <span v-if="row5.item.over_closedOverseas_status == 0" variant="success">
                  User:{{ row5.item.closedOverseas_byuser }}
                  <br />
                  Date:{{ row5.item.closedOverseas_created_at }}
                </span>
              </span>
              <span v-for="(CDitem, CD_index) in row5.item.NoteDetails" :key="CD_index">
                <EditCRDRNote v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' && CDitem.noteSeries
                  " :title="
                    'Edit ' +
                    (CDitem.creditDebitNoteType === '2' ? 'Debit' : 'Credit') +
                    ' Note : ' +
                    CDitem.noteSeries
                  " :note_id="CDitem.note_id" :noteSeries="CDitem.noteSeries" :note_page="CDitem.page"
                  :AgentType="CDitem.agentType" :creditDebitNoteType="CDitem.creditDebitNoteType"
                  :approvalStatus="CDitem.approvalStatus" :uploadCreditDebit="CDitem.uploadCreditDebit"
                  :creditDebitNote_Status="CDitem.creditDebitNote_Status" :JOBID="row5.item.allModuleId"
                  :JOBNO="row5.item.mainSalesSeries" :JOBDATE="row5.item.assDate" :JOBTYPE="row5.item.over_Jobtype" />
              </span>
              <Overseas-CRDRNote :title="row5.item.mainSalesSeries" :moduleType="row5.item.over_moduleType"
                :cr_all_module_id="row5.item.allModuleId" :cr_jb_series="row5.item.mainSalesSeries"
                :cr_ass_date="row5.item.assDate" :transportType="row5.item.over_Transport_Type"
                :Jobtype="row5.item.over_Jobtype" :commonId="row5.item.over_common_id || '0'"
                :shipmentType="row5.item.over_shipmentType" :isOverseas="true" :ItemAr="row5.item" />
              <CommonOverseaUnLock v-if="row5.item.over_closedOverseas_status == '0'"
                :title="'Open ' + row5.item.Overlock_module_type + ' Assignment'" :Overlock_item="row5.item"
                :Overlock_JOBNO="row5.item.mainSalesSeries" :Overlock_allModuleId="row5.item.allModuleId"
                :Overlock_table_name="'common_Overses'" :Overlock_table_key="'common_over_id'"
                :Overlock_table_value="row5.item.common_over_id" :Overlock_column_key="'closedOverseas_status'"
                :Overlock_column_value="row5.item.over_closedOverseas_status"
                :Overlock_module_type="row5.item.Overlock_module_type" />
              <Add-Message :fk_all_module_id="row5.item.allModuleId" :fk_client_id="row5.item.clientId"
                :fk_pod_id="row5.item.PODLocationId" style="list-style-type: none" />
              <b-button size="sm" class="mt-2" style="font-size: 0.675rem" @click="showDocModal(row5.item)"
                variant="outline-info">Summary & Documents</b-button>
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :assign_date="row5.item.loginTime | moment"
                :assign_job_type="row5.item.jobType" :assign_raised_from="'Raised From: ' + row5.item.raisedFrom"
                :assign_raised_by="'Raised By: ' + row5.item.raiesdBy" :fk_all_module_id="row5.item.allModuleId"
                :jb_series="row5.item.mainSalesSeries" :fk_client_id="row5.item.clientId"
                :fk_pod_id="row5.item.PODLocationId" />
              <Splitmerge-Summary :title="'Split & Merge Track - '" :SM_all_module_id="row5.item.allModuleId"
                :SM_jb_series="row5.item.mainSalesSeries" :SM_Status="1" class="mt-2"
                v-if="row5.item.SplitedStatus != '0'" />
                <!-- <JobWisePaymentsDetails
                  v-if="row5.item.allModuleId"
                  :allModuleId="Number(row5.item.allModuleId)"
                  :JobNo="row5.item.mainSalesSeries"
                  /> -->
                  <RejectInvTallyBillSummary
                    v-if="row5.item.allModuleId"
                    :PMC_title="'Invoice Rejection Log Summary Job No - ' + row5.item.mainSalesSeries"
                    :PMC_JOBID="row5.item.allModuleId.toString()"
                    :PMC_JOBNO="row5.item.mainSalesSeries"
                    :PMC_JOBDATE="''"
                    :PMC_JOBTYPE="''"
                    :PMC_Client="''"
                    :PMC_Sline="''"
                  />
              <ContainerSummary v-if="row5.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row5.item.mainSalesSeries"
                :PMC_JOBID="row5.item.allModuleId" :PMC_JOBNO="row5.item.mainSalesSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <!-- <b-modal
              class="modal-dialog-doc"
              size="xl"
              no-close-on-esc
              no-close-on-backdrop
              ref="doc-modal"
              hide-footer
              :title="'Assignment Summary & Documents - ' + JOBSERIES"
            >
              <div v-if="ALLMODULE">
                <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
              </div>
              <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close</b-button>
            </b-modal>-->
            <b-col md="12" class="my-1">
              <b-pagination limit="8" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalRows" @change="onPageChange($event)"></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>
    <div>
      <b-modal class="modal-dialog-doc" size="xl" no-close-on-esc no-close-on-backdrop ref="doc-modal" hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close</b-button>
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
    </div>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>

    <!-- Added By Priyanshu SIngh STart -->

    <!-- Added By Priyanshu SIngh End -->

    <!-- Modal Section Start -->
    <b-modal no-close-on-esc no-close-on-backdrop size="md" ref="CloseOverseas-modal" hide-footer title>
      <div class="d-block text-center">
        <h3>Are you sure to want close</h3>
      </div>

      <center>
        <span class="center">
          <b-button class="mt-3" variant="success" @click="SaveCloseOverseas">Yes</b-button>
          <b-button class="mt-3" variant="danger" @click="hideCloseOverseasModal">No</b-button>
        </span>
      </center>
    </b-modal>
    <!-- Modal Section End -->

    <!-- Added By Priyanshu SIngh STart -->
  </div>
</template>

<script>
import CommonService from "../../services/CommonService.js";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC, PRIDELdashboardName } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import {
  globalPermissionStatus,
  lastVisitPage,
  GlobalGetLocation,
} from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import DateRangePicker from "vue2-daterange-picker";
import XLSX from "xlsx";
import OverseasCRDRNote from "../common/overseasCRDRNote.vue";
import SplitmergeSummary from "../common/splitmergeSummary.vue";
import CommonOverseaUnLock from "../common/commonOverseaUnLock.vue";
import EditCRDRNote from "../common/editCRDRNote.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import CustomLoader from "../common/customLoader.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllAirLineList",
      JSON.stringify({
        itemCode: "AirLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
         type:'Normal',
        Territory:'',
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );

    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (globalPermissionStatus("Overseas Agent Assignments")) {
      this.$store.dispatch("setCurrentRoute", "/overseas/OtherCommonOverseas");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getAllOtherOverseasList();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      CLosedStatusList: [
        {
          inv: "1",
          int: "Closed",
        },
        {
          inv: "2",
          int: "Pending",
        },
        {
          inv: "3",
          int: "All",
        },
      ],

      ALLMODULE: "",
      JOBSERIES: "",
      PaginationList: [
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        },
      ],
      ExcelBtnName: "Export",
      PaginationCount: "",
      validate: true,
      currList: [],
      Filter: {
        shipmentTypeFilter: "all",
        ToFilter: "",
        statusFilter: "1",
        CommonFilter: "",
        branchfilter: "",
        airLineFilter: "",
        shippingLineFilter: "",
        containerTypeFilter: "",
        PODfilter: "",
        PORfilter: "",
        clientIdFilter: "",
        closedFilter: "2",
      },

      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },

      totalRows: 0,

      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      Others_Common_Overses_data: [],
      Columns: [
        {
          key: "common_over_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mainSalesSeries",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "over_type",
          label: "Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "agent_coloder_txt",
          label: "To",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "POR",
          label: "Other Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "MBLNO",
          label: "MBL/HBL",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "CountmainManifestationData",
          label: "Manifestation",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      totAmt: 0,

      ManifestationStatusList: [
        {
          inv: "1",
          int: "Recevied",
        },
        {
          inv: "2",
          int: "Pending",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      shipmentTypeList: [
        {
          payVal: "Sea",
          payText: "Sea",
        },
        {
          payVal: "Air",
          payText: "Air",
        },

        {
          payVal: "all",
          payText: "All",
        },
      ],
      overseasClosedItems: "",
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  components: {
    Loading,
    ModelListSelect,
    DocForm,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    AddMessage,
    AssignmentSummary,
    DateRangePicker,
    DatePicker,
    OverseasCRDRNote,
    SplitmergeSummary,
    CommonOverseaUnLock,
    EditCRDRNote,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },

  methods: {
    openCloseOverseasModal(item) {
      console.log("item=>", item);
      this.overseasClosedItems = item;
      this.$refs["CloseOverseas-modal"].show();
    },

    hideCloseOverseasModal() {
      this.$refs["CloseOverseas-modal"].hide();
    },
    SaveCloseOverseas() {
      console.log("overseasClosedItems=>", this.overseasClosedItems);
      let payload = {
        filter: "Others_Common_Overses_Closed",
        allModuleId: this.overseasClosedItems.allModuleId,
        ffExportFclId: this.overseasClosedItems.common_over_id,
        salesSeries: this.overseasClosedItems.mainSalesSeries,
      };
      CommonService.getAllCreditDebitNoteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.hideCloseOverseasModal();
            this.getAllOtherOverseasList();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Others_Common_Overses Error: ", error);
        });
    },
    sendCommonManifestation(item) {
      console.log("Happy SIngh=>", item);
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffExportFclId", "");
      this.$sessionsStorage.set("sendManifest_shipmentType", "");
      this.$sessionsStorage.set("sendManifest_moduleType", "");
      this.$sessionsStorage.set("sendManifest_JobSeries", "");
      this.$sessionsStorage.set("sendManifest_JOBSERIES", "");
      this.$sessionsStorage.set("sendManifest_Transport_Type", "");
      this.$sessionsStorage.set("sendManifest_Jobtype", "");
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", item.allModuleId);
      this.$sessionsStorage.set("sendManifest_ffExportFclId", item.over_common_id);
      this.$sessionsStorage.set("sendManifest_shipmentType", item.over_shipmentType);
      this.$sessionsStorage.set("sendManifest_moduleType", item.over_moduleType);
      this.$sessionsStorage.set("sendManifest_JobSeries", item.mainSalesSeries);
      this.$sessionsStorage.set("sendManifest_JOBSERIES", item.mainSalesSeries);
      this.$sessionsStorage.set("sendManifest_Transport_Type", item.over_Transport_Type);
      this.$sessionsStorage.set("sendManifest_Jobtype", item.over_Jobtype);
      this.$router.push({
        path: "/freightForwarding/CommonManifestation",
      });
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    getReportsReverse(id, btnName) {
      let excelIdGivin = "";
      if (id == "Others_Common_Overses_EXCEL") {
        excelIdGivin = "Others_Common_Overses_EXCEL";
      }
      let payload = {
        excelId: excelIdGivin,
        fromDate: this.dateSearch.fromDate,
        toDatedateRange: this.dateSearch.toDate,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName = btnName;
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    PrintNote(assignmentNo, uploadCreditDebit) {
      let key =
        "ASSIGNMENT_UPLOADS/" +
        assignmentNo.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },

    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
      let newdate = firstYear + "-04-01";
      firstDay = new Date(newdate);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    // async
    getAllOtherOverseasList() {
      this.isLoading = true;
      let payload = {
        filter: "Others_Common_Overses",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        Filter: this.Filter,
      };
      // JSON.stringify();
      // await
      CommonService.getAllCreditDebitNoteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.Others_Common_Overses_data = data.Others_Common_Overses_data;
            this.totalRows = data.Others_Common_Overses_data.length;
            console.log(" Others_Common_Overses response=>", data);
          } else {
            this.Others_Common_Overses_data = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on Others_Common_Overses Error: ", error);
        });
    },

    SearchFilter(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllOtherOverseasList();
      }, 1000);
    },
    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.reload = false;
      this.getAllOtherOverseasList();
    },

    wordWrap,
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllOtherOverseasList();
    },
    filterClear() {
      (this.Filter = {
        shipmentTypeFilter: "all",
        ToFilter: "",
        statusFilter: "1",
        CommonFilter: "",
        branchfilter: "",
        airLineFilter: "",
        shippingLineFilter: "",
        containerTypeFilter: "",
        PODfilter: "",
        PORfilter: "",
        clientIdFilter: "",
        closedFilter: "2",
      }),
        (this.dateSearch.fromDate = "");
      this.dateSearch.toDate = "";
      this.getCurrentLastDate();
      this.getAllOtherOverseasList();
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllOtherOverseasList();
    },

    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.pagination.currentPage = 1;
    },

    // Added By Priyanshu SIngh End
  },
};
</script>
<style scoped>
/* .colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
} */
</style>



// WEBPACK FOOTER //
// otherCommonOverseas.vue?2cd87cce